import { render, staticRenderFns } from "./Cellar.vue?vue&type=template&id=c085f482&"
import script from "./Cellar.vue?vue&type=script&lang=js&"
export * from "./Cellar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports